
import { TFunction } from 'i18next';
import * as Yup from 'yup';

const regex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

export const emailRequired =(t: TFunction) => Yup.string().email(t<string>("validation:email.invalidFormat"))

    .nullable().typeError(t<string>("validation:email.required")).required(t<string>("validation:email.required"))
    .matches(regex, t<string>("validation:email.invalidFormat"));
   